(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-version-state-history', {
            parent: 'entity',
            url: '/handbook-version-state-history?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersionStateHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-histories.html',
                    controller: 'HandbookVersionStateHistoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersionStateHistory');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-version-state-history-detail', {
            parent: 'handbook-version-state-history',
            url: '/handbook-version-state-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersionStateHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-detail.html',
                    controller: 'HandbookVersionStateHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersionStateHistory');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('handbookVersionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookVersionStateHistory', function($stateParams, HandbookVersionStateHistory) {
                    return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-version-state-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-version-state-history-detail.edit', {
            parent: 'handbook-version-state-history-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version-state-history.new', {
            parent: 'handbook-version-state-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateSetTimestamp: null,
                                stateOld: null,
                                stateNew: null,
                                info: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('handbook-version-state-history');
                });
            }]
        })
        .state('handbook-version-state-history.edit', {
            parent: 'handbook-version-state-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version-state-history.delete', {
            parent: 'handbook-version-state-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-delete-dialog.html',
                    controller: 'HandbookVersionStateHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
